<div *ngIf="loading">Caricamento in corso...</div>
<div *ngIf="errorMessage">{{ errorMessage }}</div>

<ng-container *ngIf="!loading && pdfSrc">
  
<div class="pdf-toolbar">
  <button (click)="downloadPdf()" class="btn btn-outline-dark-2">Scarica PDF</button>

  <div class="zoom-controls">
    <button (click)="zoomOut()">−</button>
    <span>{{ zoomLevel | number: '1.1-1' }}x</span>
    <button (click)="zoomIn()">+</button>
  </div>
</div>


  <pdf-viewer 
    [src]="pdfSrc"
    [render-text]="true" 
    [original-size]="true" 
    [show-all]="true" 
    [zoom]="zoomLevel"
    style="display: block; width: 100%; height: 90vh;"></pdf-viewer>
</ng-container>